function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useRef, useEffect } from 'react';
import { classnames, pick } from '@bydesign-ui/utils';
import { useCombineCallback } from '@bydesign-ui/hooks';
import { useLocale, usePrefixCls, useDirection } from '@byte-design/config';
import { CloseOne } from '../../common/icons';
import { InputWrapper } from '../../units/input-wrapper';
import { INPUT_COMMON_ATTRS } from '../../units/input-wrapper/const';

var useInputAddOn = function useInputAddOn(node, className, suffixClass, ref) {
  var cls = usePrefixCls(className, suffixClass);
  return node ? React.createElement("span", {
    className: cls,
    ref: ref
  }, node) : null;
};

export function Input(props) {
  var _a;

  var locale = useLocale('input.placeholder');

  var className = props.className,
      _props$needGrouped = props.needGrouped,
      needGrouped = _props$needGrouped === void 0 ? true : _props$needGrouped,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      width = props.width,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? false : _props$clearable,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      prepend = props.prepend,
      append = props.append,
      suffix = props.suffix,
      prefix = props.prefix,
      style = props.style,
      onValueChange = props.onValueChange,
      onClear = props.onClear,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onKeyPress = props.onKeyPress,
      onPressEnter = props.onPressEnter,
      onCompositionStart = props.onCompositionStart,
      onCompositionUpdate = props.onCompositionUpdate,
      onCompositionEnd = props.onCompositionEnd,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      domRef = props.domRef,
      inputRef = props.inputRef,
      inputStyle = props.inputStyle,
      _props$outlined = props.outlined,
      outlined = _props$outlined === void 0 ? true : _props$outlined,
      htmlReadOnly = props.htmlReadOnly,
      _props$filled = props.filled,
      filled = _props$filled === void 0 ? false : _props$filled,
      extra = _objectWithoutProperties(props, ["className", "needGrouped", "disabled", "type", "size", "width", "invalid", "clearable", "value", "prepend", "append", "suffix", "prefix", "style", "onValueChange", "onClear", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "onKeyPress", "onPressEnter", "onCompositionStart", "onCompositionUpdate", "onCompositionEnd", "onMouseEnter", "onMouseLeave", "domRef", "inputRef", "inputStyle", "outlined", "htmlReadOnly", "filled"]);

  var rtl = useDirection() === 'rtl';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      paddingLeft = _useState6[0],
      setPaddingLeft = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      paddingRight = _useState8[0],
      setPaddingRight = _useState8[1];

  var prefixRef = useRef(null);
  var suffixRef = useRef(null);
  useEffect(function () {
    var _a, _b;

    var suffixWidth = (_a = suffixRef === null || suffixRef === void 0 ? void 0 : suffixRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
    var prefixWidth = (_b = prefixRef === null || prefixRef === void 0 ? void 0 : prefixRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth;
    prefixWidth && setPaddingLeft(prefixWidth + 16);
    suffixWidth && setPaddingRight(suffixWidth + 16);
  }, []);
  var handleMouseEnter = useCombineCallback(function () {
    return setHover(true);
  }, onMouseEnter);
  var handleMouseLeave = useCombineCallback(function () {
    return setHover(false);
  }, onMouseLeave);
  var handleFocus = useCombineCallback(function () {
    return outlined && setFocus(true);
  }, onFocus);
  var handleBlur = useCombineCallback(function () {
    return outlined && setFocus(false);
  }, onBlur);
  var grouped = usePrefixCls('can-input-grouped', {
    focus: focus
  });
  var wrapperCls = classnames(usePrefixCls('input-wrapper', {
    size: size,
    rtl: rtl
  }), needGrouped ? grouped : '', className);
  var inputCls = usePrefixCls('input', {
    size: size
  });
  var suffixCls = usePrefixCls('input-suffix');
  var clearCls = classnames(usePrefixCls('input-close-icon'), suffixCls);
  var prependElement = useInputAddOn(prepend, 'input-prepend');
  var appendElement = useInputAddOn(append, 'input-append');
  var prefixElement = useInputAddOn(prefix, 'input-prefix', {}, prefixRef);
  var suffixElement = useInputAddOn(suffix, 'input-suffix', {}, suffixRef);

  var _pick = pick(extra, [].concat(_toConsumableArray(INPUT_COMMON_ATTRS), ['onClick'])),
      _pick2 = _slicedToArray(_pick, 2),
      inputAttrs = _pick2[0],
      labelAttrs = _pick2[1];

  var readOnly = inputAttrs.readOnly;
  var inputInnerWrapperCls = usePrefixCls('input-inner__wrapper', {
    border: Boolean(outlined),
    size: size,
    hover: hover,
    focus: focus,
    disabled: disabled,
    readOnly: readOnly,
    warning: invalid && !disabled && !readOnly,
    'add-prepend': !!prepend,
    'add-append': !!append,
    'add-prefix': !!prefix,
    'add-suffix': !!(suffix || clearable),
    rtl: rtl,
    filled: filled
  });
  return React.createElement("span", Object.assign({}, labelAttrs, {
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width
    }),
    className: wrapperCls,
    ref: domRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }), prependElement, React.createElement(InputWrapper, Object.assign({}, inputAttrs, {
    className: inputInnerWrapperCls,
    style: rtl ? {
      paddingRight: paddingLeft,
      paddingLeft: paddingRight
    } : {
      paddingLeft: paddingLeft,
      paddingRight: paddingRight
    },
    inputClassName: inputCls,
    inputStyle: inputStyle,
    prefix: prefixElement,
    suffix: suffixElement,
    clear: !readOnly && clearable && hover && React.createElement(CloseOne, {
      theme: "filled",
      className: clearCls
    }),
    placeholder: (_a = inputAttrs.placeholder) !== null && _a !== void 0 ? _a : locale,
    type: type,
    disabled: disabled,
    value: value,
    onChange: onChange,
    onValueChange: onValueChange,
    onClear: onClear,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onKeyPress: onKeyPress,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onPressEnter: onPressEnter,
    onCompositionStart: onCompositionStart,
    onCompositionUpdate: onCompositionUpdate,
    onCompositionEnd: onCompositionEnd,
    inputRef: inputRef,
    htmlReadOnly: htmlReadOnly
  })), appendElement);
}